module.exports = __webpack_public_path__ + "assets/img/1.e7710bfb.jpg";